import { render } from "./role.vue?vue&type=template&id=241b063c&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=241b063c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-241b063c"

export default script